module.exports = __webpack_public_path__ + "img/banner_bg_002.db1d693.png";